/**
 * Orders API
 * Orders API
 *
 * The version of the OpenAPI document: 2.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';


class Tag {
    
    constructor(id, title) { 
        
        Tag.initialize(this, id, title);
    }

    
    static initialize(obj, id, title) { 
        obj['id'] = id;
        obj['title'] = title;
    }

    
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new Tag();

            if (data.hasOwnProperty('id')) {
                obj['id'] = ApiClient.convertToType(data['id'], 'String');
            }
            if (data.hasOwnProperty('title')) {
                obj['title'] = ApiClient.convertToType(data['title'], 'String');
            }
        }
        return obj;
    }


}


Tag.prototype['id'] = undefined;


Tag.prototype['title'] = undefined;






export default Tag;

